export default theme => ({
  chip: {
    padding: 8,
    borderRadius: 30,
    float: 'right',
    position: 'relative',
  },
});
